import Swiper, {Navigation, Lazy, Keyboard, A11y, EffectCoverflow, Autoplay} from 'swiper';

Swiper.use([Navigation, Lazy, Keyboard, A11y, EffectCoverflow, Autoplay]);

const initSliders = () => {
    const galleries = document.querySelectorAll('.ume-slider-wrapper');
    if (!galleries.length) return;

    const autoplaySliders = [];

    galleries.forEach(gallery => {
        const auto = gallery.getAttribute('data-autoplay');
        const swiperContainer = gallery.querySelector('.swiper-container');
        const random = gallery.getAttribute('data-random');
        const slides = gallery.getAttribute('data-slides');
        const countSlides = gallery.querySelectorAll('.swiper-slide');
        const swiperWrapper = gallery.querySelector('.swiper-wrapper');

        let desktop = 1;
        let tablet = 1;
        if (slides !== '') {
            desktop = 3;
            tablet = 2;
        }
        if (swiperWrapper.classList.contains('is-gallery-slider')) {
            desktop = slides;
            tablet = Math.ceil(slides / 2) < 5 ? Math.ceil(slides / 2) : 2;
        }
        swiperContainer.setAttribute('data-desktop', desktop);
        swiperContainer.setAttribute('data-tablet', tablet);

        const prevSlide = gallery.querySelector('.swiper-button-prev');
        const nextSlide = gallery.querySelector('.swiper-button-next');

        const swiper = new Swiper(swiperContainer, {
            direction: 'horizontal',
            grabCursor: true,
            initialSlide: random !== '' ? Math.floor(Math.random() * (countSlides.length + 1)) : 0,
            speed: 600,
            loop: swiperContainer.getAttribute('data-loop'),
            slidesPerView: 1,
            breakpoints: {
                1268: {
                    slidesPerView: swiperContainer.getAttribute('data-desktop'),
                    spaceBetween: 16,
                },
                780: {
                    slidesPerView: swiperContainer.getAttribute('data-tablet'),
                    spaceBetween: 16,
                },
            },
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
            a11y: {
                prevSlideMessage: 'Zurück',
                nextSlideMessage: 'Weiter',
            },
            centeredSlides: false,
            navigation: {
                nextEl: nextSlide,
                prevEl: prevSlide,
            },
        });

        if (auto === 'autoplay') {
            autoplaySliders.push({
                swiper,
                delay: swiperContainer.getAttribute('data-delay'),
            });
        }
    });

    if (autoplaySliders.length > 0) {
        window.addEventListener('load', () => {
            autoplaySliders.forEach(({ swiper, delay }) => {
                swiper.params.autoplay = {
                    delay,
                    disableOnInteraction: true,
                };
                swiper.autoplay.start();
            });
        });
    }
};

initSliders();
